import { render, staticRenderFns } from "./productType.vue?vue&type=template&id=5b7d8d60&"
import script from "./productType.vue?vue&type=script&lang=js&"
export * from "./productType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports